import { render, staticRenderFns } from "./CompanyCertificates.vue?vue&type=template&id=00b2a312&scoped=true"
import script from "./CompanyCertificates.vue?vue&type=script&lang=js"
export * from "./CompanyCertificates.vue?vue&type=script&lang=js"
import style0 from "./CompanyCertificates.vue?vue&type=style&index=0&id=00b2a312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2a312",
  null
  
)

export default component.exports